import * as React from 'react';

import Browser from './Browser';

/* NOTE: requires user log in */
class BrowserVisual extends React.Component {
    public render() {
        return (
            <div style={{
                width: "100vw",
                height: "100vh"
            }}>
                <Browser
                    onRef={this.voidFn}

                    dragActive={false}
                    onDragStart={this.voidFn}
                    />
            </div>
        );
    }

    public voidFn = () => {
        /* this is not empty */
    };
}

export default BrowserVisual;


// WEBPACK FOOTER //
// ./src/App/Blocks/Browser.visual.tsx